import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import Admin from "./Admin";
import Auth from "./Auth";
import DirectRedirect from "./DirectRedirect"; // <-- import your page
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

export default function App() {
  const [session, setSession] = useState(null);

  // useEffect(() => {
  //   supabase.auth.getSession().then(({ data: { session } }) => {
  //     setSession(session);
  //   });

  //   const { data: { subscription } } = supabase.auth.onAuthStateChange(
  //     (_event, session) => {
  //       setSession(session);
  //     }
  //   );

  //   console.log("session", session);
  //   return () => subscription.unsubscribe();
  // }, []);


  const ExternalRedirect = () => {
    useEffect(() => {
          window.location.replace("https://esimlive.com"); 
    }, []);

    return null; // nothing to render
  };

  return (
    <Router>
      <Routes>
        {/* If not logged in, always redirect to login */}
          <>
            <Route path="/" element={<ExternalRedirect />} />
            <Route path="/open" element={<DirectRedirect />} />
          </>
      </Routes>
    </Router>
  );
}
